<template>
  <th>
    <span v-if="profitable === null">
      <slot></slot>
    </span>
    <span v-else-if="profitable === true" class="text-success">
      <slot></slot> ✅
    </span>
    <span v-else-if="profitable === false" class="text-danger">
      <slot></slot> ❌
    </span>
  </th>
</template>

<script>
export default {
  name: 'insights-header-cell',
  props: ['profitable'],
};
</script>



// WEBPACK FOOTER //
// src/components/hit-calculator/five-card-hands-section/insights/header-cell.vue